// A simple content provider which checks for access by logged id user to restricted components
// TODO: create a HOC which does this job

import React from 'react';

import {hasRoleIn} from 'rbac/RbacHelper';
import PERMISSIONS from 'rbac/Permissions.json';

import UsabilityContext from 'lookup/UsabilityContext';
import DashboardMetrics from 'components/DashboardMetrics/DashboardMetrics';
import CodexStatusModal from 'components/CodexStatusModal';
import { isLoggedInUserAWAdmin } from 'services/AWUtilityService';
import { AgentWorkspaceConstants } from 'lookup/AgentWorkspaceConstants';

export const ROUTES = {
  // TODO: need to create a common route lookup or route provide
  // bad idea to use string literals, true for some other places in
  // the application
  // This method basically prioritizes landing pages for a user with multiple roles
  provideRedirectRoute: () => {
    if (hasRoleIn([PERMISSIONS.PERM_SWIM_WORKFLOW_ACCESS]))
      return '/dashboard';
    else if (hasRoleIn([PERMISSIONS.PERM_PAW_GROUP_USER_MANAGE]))
      return '/paw/list';
    else if (hasRoleIn([PERMISSIONS.PERM_PAW_LOAD_MANAGE]))
      return '/paw/paw-load';
    else if (hasRoleIn([PERMISSIONS.PERM_CODEX_READ]))
      return '/cat';
    else if(hasRoleIn([PERMISSIONS.PERM_AW_MANAGE]))
      // Non-admin agents land on the filter screen (flag off → screen redirects to list).
      return isLoggedInUserAWAdmin()
        ? '/agent-workspace/dashboard'
        : AgentWorkspaceConstants.AGENT_NEXT_CALL_GROUP_FILTER_PATH;
    else return '/';
  }
}

export const CODEX = {
  provideCodexStatusModal: (disabledApprovalButton) => {
    if (hasRoleIn([PERMISSIONS.PERM_CODEX_STATUS_CHANGE]))
      return <CodexStatusModal disabledButton={disabledApprovalButton}/>
    else return null;
  },
  renderComponentIfCanChangeDSG: (component) => {
    if(hasRoleIn([PERMISSIONS.PERM_CODEX_ENTITIES_CRUD]))
      return component;
    else return null;
  }
}

export const DASHBOARD_LAYOUT = {
  provideMetricsBox: () => {
    if (hasRoleIn([
      PERMISSIONS.PERM_PAW_GROUP_USER_MANAGE,
      PERMISSIONS.PERM_SCHEDULER_ACCESS,
      PERMISSIONS.PERM_BULK_ACTION_CRUD
    ]))
      return <DashboardMetrics />;
    else return null;
  }
}

export const SWITCH_DISPOSITION = {
  provideSelectableDispositions : (context) => {
    const selectableDispositions = {
      ACCEPTED: 'ACCEPTED',
      SUBMITTED_VIA_EHR: 'SUBMITTED_VIA_EHR',
      MEMBER_ON_TARGET: 'MEMBER_ON_TARGET'
    }
    if (((hasRoleIn([PERMISSIONS.PERM_PAW_GROUP_USER_MANAGE]) || hasRoleIn([PERMISSIONS.PERM_SWIM_WORKFLOW_ACCESS])) && context === UsabilityContext.RAW) || context === UsabilityContext.AW)
      selectableDispositions.DECLINED = 'DECLINED';

    return selectableDispositions;
  },

  provideSubmitToPaw : (context) => {
    if (hasRoleIn([PERMISSIONS.PERM_SWIM_WORKFLOW_ACCESS]) && context === UsabilityContext.SWIM)
      return <option value="PAW" >PAW</option>;
  }
}
